import React from 'react';

const WiFiQRForm = ({ wifiData, onDataChange }) => {
  const handleFieldChange = (field, value) => {
    onDataChange({
      ...wifiData,
      [field]: value
    });
  };

  return (
    <div className="wifi-form">
      <div className="form-group">
        <label htmlFor="wifi-ssid">Nome da Rede (SSID)</label>
        <input
          id="wifi-ssid"
          type="text"
          value={wifiData.ssid || ''}
          onChange={(e) => handleFieldChange('ssid', e.target.value)}
          placeholder="MinhaRedeWiFi"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="wifi-password">Senha</label>
        <input
          id="wifi-password"
          type="password"
          value={wifiData.password || ''}
          onChange={(e) => handleFieldChange('password', e.target.value)}
          placeholder="senha123"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="wifi-security">Tipo de Segurança</label>
        <select
          id="wifi-security"
          value={wifiData.security || 'WPA'}
          onChange={(e) => handleFieldChange('security', e.target.value)}
          className="select-input"
        >
          <option value="nopass">Sem Senha (Aberta)</option>
          <option value="WEP">WEP (Legado)</option>
          <option value="WPA">WPA/WPA2/WPA3</option>
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="wifi-hidden">Rede Ocultada</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
          <input
            id="wifi-hidden"
            type="checkbox"
            checked={wifiData.hidden || false}
            onChange={(e) => handleFieldChange('hidden', e.target.checked)}
          />
          <small>Marque se a rede não aparece na lista de redes disponíveis</small>
        </div>
      </div>

      <div className="info-box" style={{ marginTop: '1rem' }}>
        <p><strong>💡 Como usar:</strong></p>
        <ul style={{ margin: '0.5rem 0', paddingLeft: '1.5rem' }}>
          <li>Escaneie o QR Code com seu celular</li>
          <li>Toque na notificação que aparecer</li>
          <li>Conecte automaticamente à rede WiFi</li>
        </ul>
      </div>
    </div>
  );
};

export default WiFiQRForm;
